"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Button_1 = tslib_1.__importDefault(require("../../Button"));
const styled_components_1 = tslib_1.__importDefault(require("../../Themes/styled-components"));
const InputButton = (props) => React.createElement(Button_1.default, Object.assign({}, props));
exports.default = styled_components_1.default(InputButton) ``;
